export type CategoryInfo = Omit<ParentCategoryInfo, 'subforums'>

export interface ParentCategoryInfo {
  id: string
  title: string
  url: string
  type?: number | string
  displayOrder?: number
  topicCount: number
  subforums: CategoryInfo[]
  description: string
  thumbnailUrl: string
  heroImageUrl: string
  showDescriptionOnHomepage: boolean
  replyCount: number
}

export interface WidgetSetting {
  key: string
  visibility: boolean
  name: string
  url?: string
  external?: boolean
}

export function isParentCategoryInfo (category: CategoryInfo|ParentCategoryInfo): category is ParentCategoryInfo {
  return 'subforums' in category
}
